/**
 * Optimizes SVG content by removing unnecessary attributes and comments
 * @param svgContent - The raw SVG content
 * @returns Optimized SVG content
 */
export const optimizeSvg = (svgContent: string): string => {
  if (!svgContent) return svgContent;

  return svgContent
    // Remove comments
    .replace(/<!--[\s\S]*?-->/g, '')
    // Remove unnecessary whitespace
    .replace(/\s+/g, ' ')
    // Remove empty lines
    .replace(/\n\s*\n/g, '\n')
    // Remove trailing whitespace
    .trim();
};

/**
 * Injects CSS variables into SVG for theming
 * @param svgContent - The SVG content
 * @param theme - Theme object with CSS variables
 * @returns SVG content with injected CSS variables
 */
export const injectSvgTheme = (svgContent: string, theme: Record<string, string>): string => {
  if (!svgContent || !theme) return svgContent;

  let optimizedSvg = svgContent;

  // Inject CSS variables into the SVG
  Object.entries(theme).forEach(([key, value]) => {
    const regex = new RegExp(`var\\(--${key}\\)`, 'g');
    optimizedSvg = optimizedSvg.replace(regex, value);
  });

  return optimizedSvg;
}; 